import React, { Component} from "react";
// Styles
import "./ProcLevel.scss"

// Components
import Header from "components/Header";
import Level from "views/Level";
import Astronaut from 'static/img/astronaut.svg'

class ProcLevel extends Component {

  render() {
    return (
      <>
        <div className="proclayer" style={{position:'relative'}}>
         <Level>
         <Header/>
         </Level>
         <div className="welcome-wrapper5">
              <img src={Astronaut} alt="astronaut" className="astronaut" />
              <div className="nextintro">
              <p className="welcome-text welcome-text2">Maybe you can add commands to my new <span className="proc-text">PROC1</span> slot.</p>
              </div>
          </div>
        </div>
      </>
    );
  }
}
export default ProcLevel;

